"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_client_1 = require("@amzn/amazon-config-store-type-script-client");
var InMemoryConfigStorage = /** @class */ (function () {
    function InMemoryConfigStorage() {
        var _a;
        this.FEATURE_STORAGES = (_a = {},
            _a[amazon_config_store_type_script_client_1.ClientStage.SANDBOX] = new Map(),
            _a[amazon_config_store_type_script_client_1.ClientStage.DEVO] = new Map(),
            _a[amazon_config_store_type_script_client_1.ClientStage.PROD] = new Map(),
            _a);
    }
    InMemoryConfigStorage.prototype.computeIfAbsent = function (tableName, stage, computeStorage) {
        if (this.FEATURE_STORAGES[stage].get(tableName) === undefined) {
            this.FEATURE_STORAGES[stage].set(tableName, computeStorage());
        }
        return this.FEATURE_STORAGES[stage].get(tableName);
    };
    return InMemoryConfigStorage;
}());
exports.default = InMemoryConfigStorage;
